export default __webpack_public_path__ + "static/media/Electronics.6788ded0.svg";